import { createStore, combineReducers, applyMiddleware, Middleware } from 'redux';
import { createLogger } from 'redux-logger';
import { datadogLogs } from '@datadog/browser-logs';
import LogRocket from 'logrocket';

import { getLogger } from '~Hooks';
import * as reducers from './reducers';
import * as actions from './actions';

const mutedLogs = ['NEW_TABLE_DATA', 'NEW_ORDER_STATUS_DATA', 'USER_PROVIDED_INPUT'];
const reduxLogger = createLogger({
  predicate: (getState, action) => Boolean(window.__DEV__) && !mutedLogs.includes(action.type),
  collapsed: (getState, action, logEntry) => !logEntry?.error,
});

/**
 * Logs to datadog from actions
 */

const printerLogger = getLogger('printer');
const eventCountLogger = getLogger('event-count');

const datdogLogger = (store: any) => (next: any) => (action: any) => {
  if (action.type === actions.MESSAGE_PRINT_BRIDGE_REQUEST_SUCCESS) {
    printerLogger.info('Print successful', {
      id: action.id,
    });
  }

  if (action.type === actions.MESSAGE_PRINT_BRIDGE_REQUEST_FAILED) {
    printerLogger.warn('Print failed', {
      id: action.id,
      error: action.error,
    });
  }

  if (action.type === actions.LOG_EVENT_COUNT) {
    const orderStatusEventCount: number | undefined = store.getState()?.orderStatusEvents?.length;
    if (orderStatusEventCount && orderStatusEventCount > 0) {
      eventCountLogger.info(`Order status event count: ${orderStatusEventCount}`);
    }
    const tableStatusEventCount: number | undefined = store.getState()?.tableEvents?.length;
    if (tableStatusEventCount && tableStatusEventCount > 0) {
      eventCountLogger.info(`Tables event count: ${tableStatusEventCount}`);
    }
  }

  if (action.type === actions.MESSAGE_PRINTERS) {
    datadogLogs.addLoggerGlobalContext('printers', action.printers);
  }

  return next(action);
};

const reducer = combineReducers(reducers);
const store = createStore(
  reducer,
  {},
  applyMiddleware(reduxLogger, datdogLogger, LogRocket.reduxMiddleware()),
);
export type Store = typeof store;

export default store;
